import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "rotate",
    title: '',
    component: () =>
      import( "@/views/rotate.vue")
  },
  {
    path: "/vr1",
    name: "vr1",
    title: '',
    component: () =>
      import("@/views/vr1.vue")
  },
  {
    path: "/vr2",
    name: "vr2",
    title: '',
    component: () =>
      import("@/views/vr2.vue")
  },
  {
    path: "/vr3",
    name: "vr3",
    title: '',
    component: () =>
      import("@/views/vr3.vue")
  },
  {
    path: "/vr4",
    name: "vr4",
    component: () =>
      import("@/views/vr4.vue")
  },
  {
    path: "/vr5",
    name: "vr5",
    title: '',
    component: () =>
      import("@/views/vr5.vue")
  },
  {
    path: "/banner",
    name: "banner",
    title: '',
    component: () =>
      import("@/views/banner.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  base: process.env.BASE_URL,
  routes
});

export default router;
